import { Spinner } from "@/shared";

const FileProcessingPlaceHolder = ({
  selectedFile,
}: {
  selectedFile: File;
}) => {
  return (
    <div className="text-center py-12">
      <Spinner size="xl" />
      <h3 className="text-xl font-semibold text-gray-900 mb-3">
        Processing {selectedFile?.name}
      </h3>
      <div className="space-y-2 text-sm text-gray-600 max-w-md mx-auto">
        <div className="flex items-center justify-center space-x-2">
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-pulse"></div>
          <span>Parsing file data</span>
        </div>
        <div className="flex items-center justify-center space-x-2">
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-pulse delay-75"></div>
          <span>Extracting delivery locations</span>
        </div>
        <div className="flex items-center justify-center space-x-2">
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-pulse delay-150"></div>
          <span>Resolving addresses and creating legs</span>
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-4">
        This process may take 30-60 seconds depending on file size
      </p>
    </div>
  );
};

export default FileProcessingPlaceHolder;
